module.exports = __webpack_public_path__ + "assets/img/1.6abd8110.jpg";